import { ReactNode } from "react"
import { useFormSelector } from "../../../redux/formStoreHooks"
import { V2L3PrintPageHeader } from "../../uiv2/FormPage/V2L3PrintPageHeader"
import { exportDateOfServiceInfoString, exportMemberInfoString, exportMemberName, LibraryIconProp } from "@fusion-advantage/formlib"
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { L2Column, L2ColumnLayout } from "../l2/L2ColumnLayout"
import { RenderMedia } from "@fusion-advantage/backcompat"
import { selectExport } from "../../../redux/selectForm"
import { V2L1FormPageBreak } from "../../uiv2/FormPage/V2L1FormPageBreak"

interface L4PageProps {
	xpath: string
	title?: string
	icon?: IconProp|LibraryIconProp
	children: ReactNode
}

const L4Page = ({xpath, title, icon, children}: L4PageProps) => {
	const media = useFormSelector(state => state.render.media)
	const exp = useFormSelector(selectExport)
	const whiteLabelLogoURL = exp?.Form.Member.WhiteLabelLogoURL
	if(media !== RenderMedia.Print) {
		return children
	}
	return (
		<>
			<L2ColumnLayout columnCount={1}>
				<L2Column>
					<V2L3PrintPageHeader
						logoSrc={whiteLabelLogoURL}
						isFirstPage={xpath.endsWith('[0]')}
						patientName={exportMemberName(exp)}
						encounterDetail={exportMemberInfoString(exp) + ', ' + exportDateOfServiceInfoString(exp)}
						tabTitle={title}
						tabIcon={icon}
					/>
				</L2Column>
			</L2ColumnLayout>
			{children}
			<V2L1FormPageBreak>&nbsp;</V2L1FormPageBreak>
		</>
	)
}

export default L4Page
